/**
 * Helpers for the paginated staff list endpoints (GET /staff/videos and
 * GET /staff/playlists). Both take `page` (1-based) and `pageSize` (0 to
 * 500, default 100; 0 returns only `count`) and respond with
 * { count, page, pageSize, next, previous, results }.
 */

/** Rows per page. The server defaults to 100 and allows up to 500. */
export const DEFAULT_PAGE_SIZE = 100;

/**
 * Path for one page of a list endpoint.
 *
 * @param {string} path - e.g. '/staff/videos'
 * @param {{ page?: number, pageSize?: number }} [options]
 * @returns {string} e.g. '/staff/videos?page=1&pageSize=100'
 */
export function pagePath(path, { page = 1, pageSize = DEFAULT_PAGE_SIZE } = {}) {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  return `${path}?${params}`;
}

/**
 * The rows of a cached page, so hooks can keep returning a plain array.
 *
 * @template T
 * @param {{ results?: T[] }|undefined} listPage
 * @returns {T[]}
 */
export function pageResults(listPage) {
  return Array.isArray(listPage?.results) ? listPage.results : [];
}
